<template>
    <div>
        <p v-text="text"></p>
        <v-switch v-for="item in items" v-model="checked" :key="item.id" :label="item.name" :value="item.id"></v-switch>
        <v-btn color="primary" :disabled="disable" @click="handleSubmitQuestion">Submit</v-btn>
    </div>
</template>
<script>
    export default {
        name: 'GroupMultipleQuestion',
        methods: {
            handleSubmitQuestion() {
                this.disable = true;
                this.$emit('evidenceDefined', this.items.map((i) => {
                    return {id: i.id, choice_id: this.checked.includes(i.id) ? "present" : "absent"}
                }));
            }
        },
        watch: {
            text() {
                this.checked = [];
                this.disable = false;
            }
        },
        props: ['text', 'items'],
        data: () => ({
            checked: [],
            disable: false,
        }),
    }
</script>